export default {
  indexEndpoint: '/user-global',
  storeEndpoint: '/user-global',
  editEndpoint: '/user-global/',
  updateEndpoint: '/user-global/',
  deleteEndpoint: '/user-global/',
  changePasswordEndpoint: '/user-global/password-user/',
}
